class BtpTabs extends HTMLElement {
  connectedCallback() {
    this._btns = this.querySelectorAll('.btp-pb__tab-btn');
    this._panels = this.querySelectorAll('.btp-pb__tab-panel');
    this._btns.forEach(btn => btn.addEventListener('click', () => this._activate(btn)));
  }

  _activate(activeBtn) {
    this._btns.forEach(btn => {
      btn.classList.toggle('is-active', btn === activeBtn);
      btn.setAttribute('aria-selected', btn === activeBtn ? 'true' : 'false');
    });
    const panelKey = activeBtn.dataset.tab;
    this._panels.forEach(panel => {
      panel.classList.toggle('is-active', panel.dataset.panel === panelKey);
    });
  }
}

if (!customElements.get('btp-tabs')) {
  customElements.define('btp-tabs', BtpTabs);
}
